module.exports = __webpack_public_path__ + "img/rz-theta.02cbeed4.svg";